// =========================
// IMAGE SOURCES for "Stay With Us" section
// =========================
// Premium Tree House images - Comprehensive gallery
// Curated for maximum visual impact and booking conversion

export const IMAGES = {
  // Hero background for the Stay section
  hero: "https://drive.google.com/uc?export=view&id=1aiEZjSis1jW0XIe0BixHfXrWKqoTQXjU",

  // Premium Tree House Cottages - Complete gallery with all premium images
  // Ordered strategically: Hero shots first, then interiors, views, and details
  treehouse: [
    // === HERO & EXTERIOR SHOTS (Maximum impact first) ===
    "/treehouse/treehouse-artifact-exterior.jpg",    // Tree house with mountain backdrop
    "/treehouse/treehouse-new-26.jpg",               // Premium exterior
    "/treehouse/treehouse-new-04.jpg",               // Daytime exterior
    
    // === WATERFALL & NATURE VIEWS (Unique selling point) ===
    "/treehouse/treehouse-artifact-waterfall.jpg",   // Stunning waterfall view
    "/treehouse/treehouse-artifact-forestview.jpg",  // Lush forest view from treehouse
    "/treehouse/treehouse-new-11.jpg",               // Valley panorama
    "/treehouse/treehouse-new-17.jpg",               // Nature scenery
    
    // === BEDROOM & INTERIORS (Comfort showcase) ===
    "/treehouse/treehouse-master-bed-swans.jpg",     // Romantic swan towel art
    "/treehouse/treehouse-interior-full.jpg",        // Full interior with stairs
    "/treehouse/treehouse-bedroom-view.jpg",         // Bedroom with curtains
    "/treehouse/treehouse-bedroom-side.jpg",         // Full room layout
    "/treehouse/treehouse-upstairs-bed.jpg",         // Upstairs sleeping area
    "/treehouse/treehouse-new-19.jpg",               // Interior detail
    "/treehouse/treehouse-new-07.jpg",               // Room interior
    
    // === BALCONY & OUTDOOR SPACES ===
    "/treehouse/treehouse-balcony-view.jpg",         // Mountain backdrop view
    "/treehouse/treehouse-balcony-entrance.jpg",     // Wooden architecture
    "/treehouse/treehouse-balcony-1.jpg",            // Warm lighting
    "/treehouse/treehouse-balcony-sitout.jpg",       // Outdoor sitting
    "/treehouse/treehouse-new-28.jpg",               // Balcony view
    "/treehouse/treehouse-new-25.jpg",               // Deck area
    
    // === ADDITIONAL PREMIUM SHOTS ===
    "/treehouse/treehouse-new-23.jpg",
    "/treehouse/treehouse-new-10.jpg",
    "/treehouse/treehouse-new-16.jpg",
    "/treehouse/treehouse-new-24.jpg",
    "/treehouse/treehouse-new-14.jpg",
    "/treehouse/treehouse-new-18.jpg",
    "/treehouse/treehouse-new-01.jpg",
    "/treehouse/treehouse-new-09.jpg",
    "/treehouse/treehouse-new-08.jpg",
    "/treehouse/treehouse-new-22.jpg",
    "/treehouse/treehouse-new-20.jpg",
    "/treehouse/treehouse-new-03.jpg",
    "/treehouse/treehouse-new-05.jpg",
    "/treehouse/treehouse-new-02.jpg",
    "/treehouse/treehouse-new-12.jpg",
    "/treehouse/treehouse-new-13.jpg",
    "/treehouse/treehouse-new-21.jpg",
    "/treehouse/treehouse-new-15.jpg",
    "/treehouse/treehouse-new-06.jpg",
    "/treehouse/treehouse-new-27.jpg",
  ],

  // Mud House Retreat - Authentic earth-toned living
  // Traditional Kerala architecture with modern comforts
  mudhouse: [
    "/mudhouse/mudhouse-collage.png",  // Premium collage: exterior, bedroom, kitchen, valley view
  ],

  // Stone Villa with Private Pool - Luxury & Privacy
  // Premium accommodation with exclusive pool access
  stonevilla: [
    "https://drive.google.com/uc?export=view&id=1EBrNFrH1tWT1khiKy8dIzXF0ox8bpMNc",
    "https://drive.google.com/uc?export=view&id=1Kchwj4U7sF7ThZztmhkTDFF95py90TXd",
    "https://drive.google.com/uc?export=view&id=1VOJR5FaeXCSA69SEPveIj6zpMPfGdj9c",
    "https://drive.google.com/uc?export=view&id=1XGM7aNTqdgpidR1mqSDQ8354KrqUJkxl",
    "https://drive.google.com/uc?export=view&id=1c1VA8LDO5VXZBUCo_j6H6aWfdU-fB6Q_",
    "https://drive.google.com/uc?export=view&id=1rzJpRtlDPJcLMU_CcRSgBhkSeMW0EN_6",
    "https://drive.google.com/uc?export=view&id=1vYmUT3RL3KKwqgHbvf3K_2d96wrFScaK",
  ],
};
